import React from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"

const doseOptions = [
  { value: "first_dose", label: "1st Dose" },
  { value: "second_dose", label: "2nd Dose" },
]

const VaccineDoseDropdown = ({ control, name, onSelectChange, target, placeholder }) => {
  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={doseOptions}
              // placeholder={placeholder ? placeholder : "Select Dose"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              menuPortalTarget={document.querySelector(
                target ? target : ".modal"
              )}
            />
          )
        }}
      />
    </div>
  )
}

export default VaccineDoseDropdown